import React from "react";

import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { PageContent } from "@/uiKit/atoms/page/PageContent.tsx";
import { PageHeader } from "@/uiKit/atoms/page/PageHeader.tsx";
import { PageWithDrawer } from "@/uiKit/atoms/page/PageWithDrawer.tsx";
import { InclusionCenterDrawer } from "@/uiKit/organisms/InclusionCenter/InclusionCenterDrawer.tsx";
import { InclusionCenterFloatingButton } from "@/uiKit/organisms/InclusionCenter/InclusionCenterFloatingButton.tsx";
import { DoctorPatientListCard } from "@/uiKit/organisms/PatientsList/DoctorPatientListCard.tsx";

export const PatientListForDoctorsPage: React.FC = () => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  return (
    <PageWithDrawer
      id="doctor-patients-list-page"
      drawer={<InclusionCenterDrawer alignWithPageContent />}
      floatingAction={<InclusionCenterFloatingButton />}
    >
      <PageHeader id="doctor-patients-list-page-title" title={t("pages.patients.title")} />
      <PageContent id="doctor-patients-list-page-content">
        <DoctorPatientListCard className={styles.patientsList} />
      </PageContent>
    </PageWithDrawer>
  );
};

const makeStyles = () => ({
  patientsList: css({
    flex: "1 1",
  }),
});
